import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import ReceiptGenerator from "../components/ReceiptGenerator";
import "../assets/css/ReceiptGenerator.css";

function GenerateProjectReceipt() {
  const navigate = useNavigate();

  return (
    <div className="viewlead-container generate-receipt-page-container">
      <div className="viewlead-header" style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="viewlead-back-link"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft /> Back
        </button>
      </div>
      <ReceiptGenerator />
    </div>
  );
}

export default GenerateProjectReceipt;
